import { render, staticRenderFns } from "./AddToBucket.vue?vue&type=template&id=1ddf8f3e&scoped=true&"
import script from "./AddToBucket.vue?vue&type=script&lang=js&"
export * from "./AddToBucket.vue?vue&type=script&lang=js&"
import style0 from "./AddToBucket.vue?vue&type=style&index=0&id=1ddf8f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf8f3e",
  null
  
)

component.options.__file = "AddToBucket.vue"
export default component.exports